<script>
import "swiper/swiper-bundle.css";
import Swiper, { EffectFade, Autoplay, Navigation, Pagination } from "swiper";
Swiper.use([EffectFade, Autoplay, Navigation, Pagination]);

export default {
  name: "BlockSlider",
  props: {
    timeout: {
      type: Number,
      default: 3000,
    },
    numSlides: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    if (this.numSlides > 0) {
      this.swiper = new Swiper(this.$refs.swiper, {
        slidesPerView: 1,
        spaceBetween: 30,
        effect: "fade",
        loopPreventsSlide: false,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: this.timeout,
        },
        navigation: {
          prevEl: this.$refs.prev,
          nextEl: this.$refs.next,
        },
        pagination: {
          el: this.$refs.pagination,
          type: 'bullets',
          clickable: true
        },
      });

      this.swiper.autoplay.start();
    }
  },
};
</script>

<template>
  <div class="block-slider">
    <div ref="swiper" class="swiper-container">
      <div class="swiper-wrapper">
        <slot />
      </div>
    </div>
    <button v-if="numSlides > 1" type="button" class="prev" ref="prev">
      <svg-icon icon="arrow" />
    </button>
    <button v-if="numSlides > 1" type="button" class="next" ref="next">
      <svg-icon icon="arrow" />
    </button>
    <div class="slider-pagination" ref="pagination"></div>
  </div>
</template>

<style lang="scss" scoped>
.block-slider {
  position: relative;

  .prev,
  .next {
    position: absolute;
    top: 50%;
    width: 40px;
    height: 40px;
    margin: -20px;
    z-index: 20;
    border: none;
    background: none;
    padding: 0;
    color: #fff;
    cursor: pointer;

    &:before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 40px;
      height: 40px;
      background: $color-dark;
      opacity: 0.5;
      border-radius: 5px;
      transform: rotate(45deg);
      transition: background-color 0.3s, opacity 0.3s;
    }

    &:hover {
      &:before {
        background: $color-brand-1;
        opacity: 1;
      }
    }

    .icon {
      display: block;
      margin: 0 auto 0 auto;
      position: relative;
    }

    @media screen and (max-width: 1300px) {
      display: none;
    }
  }

  .prev {
    left: 75px;

    @media screen and (max-width: 1400px) {
      left: 35px;
    }
  }

  .next {
    right: 75px;

    @media screen and (max-width: 1400px) {
      right: 35px;
    }

    .icon {
      transform: scale(-1);
    }
  }

  .slider-pagination {
    display: none !important;
    position: absolute;
    z-index: 10;
    bottom: 20px;
    left: 50%;
    width: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1300px) {
      display: flex !important;
    }
  }
}
</style>

<style lang="scss">
.block-slider {
  .swiper-slide {
    position: relative;
  }

  .image {
    display: block;
    width: 100%;

    @media screen and (max-width: 700px) {
      height: calc(100vh - 60px);
      object-fit: cover;
    }
  }

  .content {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 20px 0 20px 0;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: center;

    .center-wrap {
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-start;
      justify-content: center;

      &.left {
        align-items: flex-start;
        text-align: left;
      }

      &.center {
        align-items: center;
        text-align: center;
      }

      &.right {
        align-items: flex-end;
        text-align: right;
      }
    }

    .title {
      color: #fff;
      font-weight: 600;
      font-size: 48px;
      line-height: 1.1;
      margin-bottom: 23px;
      max-width: 950px;

      @media screen and (max-width: 1300px) {
        font-size: calc(3vw) !important;
      }

      @media screen and (max-width: 700px) {
        font-size: calc(4vw) !important;
      }

      @media screen and (max-width: 500px) {
        font-size: 26px !important;
      }
    }

    .description {
      color: #fff;
      font-size: 24px;
      line-height: 1.3;
      max-width: 700px;

      @media screen and (max-width: 1300px) {
        font-size: calc(1.8vw) !important;
      }

      @media screen and (max-width: 700px) {
        font-size: 16px !important;
      }
    }

    .primary-button {
      margin-top: 40px;

      @media screen and (max-width: 800px) {
        margin-top: 5vw !important;
      }
    }
  }

  .slider-pagination {
    .swiper-pagination-bullet {
      flex-grow: 0;
      flex-shrink: 0;
      width: 10px;
      height: 10px;
      margin: 0 5px 0 5px;
      opacity: 1;
      background: $color-brand-1;
      transition: 0.3s;
    }

    .swiper-pagination-bullet-active {
      background: #fff;
    }
  }
}
</style>
